import type { FaireProductEntity } from "../../entity_types/product";

export const p_vud5xtehgy: FaireProductEntity = {
  token: "p_vud5xtehgy",
  type: "product",
  name: "The Magic of Childhood",
  brandToken: "b_d93d4i84y7",
  brandName: "Paper Peony Press",
  imageUrl:
    "https://cdn.faire.com/fastly/f720c6e6005ab7e9bb01a67a6006382e2f578113077bfe748433104f1f94b784.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/264a46c14cf35916e58f63bcff68dcb8a1330a93b13b67f73b2ba2b5cea44c83.jpeg",
    "https://cdn.faire.com/fastly/934aa4fd81e121ae56ce055baff49f18cfe0fc4abe83070d27c528d703474d33.jpeg",
    "https://cdn.faire.com/fastly/e591cb9277b1fdd2552c7fd5e3923270c526422062e76ac67b2e081d756328f0.jpeg",
    "https://cdn.faire.com/fastly/4a18285dbbcf493e007ea9c52b9dbbcbe13a8cded4c43f5b972f063e7258e424.jpeg",
    "https://cdn.faire.com/fastly/49eb179e2fb40a6d9f2f376eaa4a34f438aa7f2919bd5e7bf46bd57b0900c0fd.png",
  ],
  priceDollars: 34.64,
  description:
    "The Magic of Childhood is a 52-week Christian homeschool curriculum that weaves together faith, nature exploration, the joy of play (or play-based learning) and developmental activities to create meaningful learning moments that honor your child's natural curiosity.\n\nWhat's Included:\nFlash Card Pages: Full sets of vocabulary cards for all 52 units, printed and ready for cutting\nLetter and Number Cards: Full sets of alphabet (Aa-Zz) and number cards (1-10) to cut out\nWeekly Faith Devotionals: Age-appropriate Bible verses and stories that build spiritual foundations\nNature-Based Learning Activities: Weekly outdoor exploration and hands-on discovery guides\n\nPerfect for beginning Homeschool Families seeking a structured yet flexible approach!\n\nWritten by Claire Mariah Murray, a seasoned kindergarten teacher with early childhood education expertise, this curriculum creates beautiful rhythms of faith, nature, play and connection in your home. ",
  tags: [],
  msrpDollars: 69.27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:39.569Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
